module.exports = __webpack_public_path__ + "static/testEntrance-9cd8ea7e28c70e711c516bc888f1861a.jpg";